<template>
    <div>
        <input type="text" v-model="displayValue" :placeholder="placeholder" @blur="isInputActive = false" @focus="isInputActive = true" />
    </div>
</template>
<script>
export default {
  data () {
    return {
      initialValue: this.amount,
      isInputActive: false
    }
  },
  props: {
    placeholder: {
      default: '',
      type: String,
      required: false
    },
    amount: {
      default: 0,
      type: String | Number,
      required: false
    }
  },
  computed: {
    displayValue: {
      get: function () {
        if (this.isInputActive && this.initialValue !== '') {
          return parseInt(this.initialValue)
        } else {
          return this.formatValue(this.initialValue)
        }
      },
      set: function (modifiedValue) {
        if (modifiedValue) {
          this.initialValue = parseInt(modifiedValue)
        } else {
          this.initialValue = modifiedValue
        }
      }
    }
  },
  methods: {
    formatValue (amount) {
      let ret = 0
      if (Number.isFinite(parseInt(amount))) {
        try {
          ret = this.$t('components.core.day-input.day') + ' ' + amount
        } catch (err) {
          ret = 0
        }
      } else {
        ret = ''
      }
      return ret
    }
  },
  watch: {
    initialValue (val) {
      this.$emit('update:amount', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/DayInput.vue